// core version + navigation, pagination modules:
import { $qs, $qsa } from "./utils/QuerySelector";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function admissionsProcess() {
	entryPointSteps();
	keyDatesToggle();
}

function ageTabs() {}

function keyDatesToggle() {
	const keyDatesToggle = $qsa('[data-name="key-dates-toggle"]');
	if (!keyDatesToggle) return;

	[...keyDatesToggle].forEach((item) => {
		item.addEventListener("click", () => {
			const plus = $qs(".plus-vert", item);

			if (item.classList.contains("dates-open")) {
				gsap.to(item.nextElementSibling, { y: "100%" });
				gsap.to(plus, { scaleY: "1", transformOrigin: "center", opacity: 1 });
				item.classList.remove("dates-open");
			} else {
				gsap.to(item.nextElementSibling, { y: "-1px" });
				gsap.to(plus, {
					scaleY: "0",
					transformOrigin: "center",
					opacity: 0,
				});

				item.classList.add("dates-open");
			}
		});
	});
}

function entryPointSteps() {
	const entryPointSteps = $qsa('[data-name="entry-point-steps"]');

	if (!entryPointSteps) return;

	[...entryPointSteps].forEach((item) => {
		const steps = $qsa('[data-name="step"]', item);
		[...steps].forEach((step, index) => {
			let scrollTL = new gsap.timeline({ ease: "linear", paused: true });
			//console.info(step.id);
			const stepListItem = $qs('a[href="#' + step.id + '"]');
			scrollTL
				.fromTo(step, { opacity: 0.2 }, { opacity: 1 }, "start")
				.fromTo(stepListItem, { opacity: 0.4 }, { opacity: 1 }, "start");

			let toggleActions = "play reverse play reverse";
			if (index == 0) toggleActions = "play reverse play none";
			if (index == steps.length - 1)
				toggleActions = "play reverse play reverse";
			ScrollTrigger.create({
				animation: scrollTL,
				trigger: step,
				start: "top center",
				end: "bottom center",
				toggleActions: toggleActions,

				// markers: true,
			});
		});
	});
}

export default admissionsProcess;
